import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { computed } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Planbook, PlanbookCalendarDate } from "@shared/models/planbook"
import type { RotationCalendar, RotationCalendarRotation } from "@shared/models/rotation-calendar"
import findDocument from "cc-frontend/helpers/find-document"
import { filter, find, first } from "lodash-es"

@tagName("")
export default class PlanbookWeeklyOrderDayProviderComponent extends Component {
  // args
  rotationCalendar!: RotationCalendar
  rotation!: RotationCalendarRotation
  planbook!: Planbook

  @service("ember-store") store

  @computed("rotationCalendar.attributes.semesters.@each.id")
  get semester() {
    return first(this.rotationCalendar.attributes.semesters)
  }

  @computed("rotation", "rotationCalendar.attributes.version")
  get rotationTemplate() {
    let semester = first(this.rotationCalendar.attributes.semesters)
    if (semester === undefined) throw Error("No Semester")
    let semesterId = semester.id
    let rotationId = this.rotation.id

    return find(
      filter(
        this.planbook.attributes.calendar.dates,
        (date: PlanbookCalendarDate) => date.type === "planbook-date-default"
      ),
      (date) => {
        return (
          // @ts-ignore
          date.attributes.rotationId === rotationId && date.attributes.semesterId === semesterId
        )
      }
    )
  }

  @findDocument("rotationTemplate.attributes.cardStackId", "card-stack") routine
}
